import request from './request';

/**
 *
 * @param cursor
 * @param filters
 * @returns {Promise<unknown>}
 */
function getAll(cursor, filters) {
    const isValidQuery = typeof filters.query === 'string' && filters.query.length > 0;
    const queryParams = new URLSearchParams({
        cursor,
        ...(isValidQuery ? { query: filters.query } : {}),
        sortBy: filters.sortBy,
        sortDirection: filters.sortDirection,
        type: filters.type,
        submittedBy: filters.submittedBy,
        status: filters.status,
        assignedTo: filters.assignedTo,
        ...(filters.userID ? { userID: filters.userID } : {})
    });

    const options = {
        endpoint: `/changeRequests?${ queryParams.toString() }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param changeRequestID
 * @param body
 * @returns {Promise<unknown>}
 */
function update(changeRequestID, body) {
    const options = {
        endpoint: `/changeRequests/${ changeRequestID }`,
        method: 'PUT',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param changeRequestID
 * @returns {Promise<unknown>}
 */
function resendReviewEmail(changeRequestID) {
    const options = {
        endpoint: `/changeRequests/${ changeRequestID }/sendLink`,
        method: 'POST'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param changeRequestID
 * @returns {Promise<unknown>}
 */
function getFile(changeRequestID) {
    const options = {
        endpoint: `/changeRequests/${ changeRequestID }/file`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param changeRequestID
 * @param changeRequest
 * @returns {Promise<unknown>}
 */
function approve(changeRequestID, changeRequest) {
    const options = {
        endpoint: `/changeRequests/${ changeRequestID }/approve`,
        method: 'PUT',
        body: { 
            changeRequest 
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param changeRequestID
 * @param changeRequest
 * @returns {Promise<unknown>}
 */
function decline(changeRequestID, changeRequest) {
    const options = {
        endpoint: `/changeRequests/${ changeRequestID }/decline`,
        method: 'PUT',
        body: { 
            changeRequest 
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} changeRequestID 
 */
function downloadChangeRequestPdf(changeRequestID) {
    const options = {
        endpoint: `/changeRequests/${ changeRequestID }/downloadPdf`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    getAll,
    update,
    resendReviewEmail,
    getFile,
    approve,
    decline,
    downloadChangeRequestPdf
};